import 'angular:locale/data:en-US';
import 'angular:locale/data:da';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
